import { yup } from '@framework/validation/initYup.ts';
import { useMemo } from 'react';
import {
  Datatype,
  type FieldDatatype,
} from '../../../../expressions/datatype/Datatype.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { DefaultValueInput } from '../../common/DefaultValueInput.tsx';
import { AdvancedSelectOptionItemList } from '../advanced-select-common/config/AdvancedSelectOptionItemList.tsx';
import { AdvancedSelectWidgetConfigComponent } from '../advanced-select-common/config/AdvancedSelectWidgetConfigComponent.tsx';
import { AdvancedSelectWidgetCommonConfigSchema } from '../advanced-select-common/config/AdvancedSelectWidgetConfigSchema.ts';
import { getUniqueOptionValue } from '../advanced-select-common/utils/geUniqueOptionValue.ts';
import { renderAdvancedSelectedOptionLabel } from '../advanced-select-common/utils/renderAdvancedSelectedOptionLabel.ts';
import { type IAdvancedSingleSelectWidget } from './IAdvancedSingleSelectWidget.ts';

export const AdvancedSingleSelectWidgetConfigSchema =
  AdvancedSelectWidgetCommonConfigSchema.shape({
    type: yup.string().exact(WidgetType.AdvancedSelect).required(),
  });

export interface IAdvancedSingleSelectWidgetConfigComponentProps
  extends IWidgetComponentProps<IAdvancedSingleSelectWidget> {}

/**
 * Componente di configurazione del widget di selezione singola avanzata
 */
export function AdvancedSingleSelectWidgetConfigComponent(
  props: IAdvancedSingleSelectWidgetConfigComponentProps,
) {
  const fieldDataType: FieldDatatype = useMemo(() => {
    return {
      type: Datatype.String,
      options: props.widget.options.map(opt => ({
        value: getUniqueOptionValue(props.widget, opt),
        label: renderAdvancedSelectedOptionLabel(
          opt.values,
          props.widget.labelFieldColumns,
          props.widget.columns,
        ),
      })),
    };
  }, [props.widget.options, props.widget]);

  return (
    <AdvancedSelectWidgetConfigComponent
      {...props}
      panelTitle="Scelta Singola Avanzata"
      panelKey="advancedSingleSelect"
      optionListComponent={<AdvancedSelectOptionItemList name="options" />}
      labelFieldColumnsHelp="Seleziona le colonne da mostrare riguardo l'opzione selezionata (es: Nome - Cognome - Città) nei campi di riepilogo, ovvero quando la finestra modale di selezione è chiusa."
      defaultNode={<DefaultValueInput forceFieldDataType={fieldDataType} />}
    />
  );
}
